class CatalinaHeroSlider {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-catalina-track]');
    this.slides = Array.from(root.querySelectorAll('[data-catalina-slide]'));
    this.dots = Array.from(root.querySelectorAll('[data-catalina-dot]'));
    this.prev = root.querySelector('[data-catalina-prev]');
    this.next = root.querySelector('[data-catalina-next]');
    this.index = 0;
    this.timer = null;
    this.interval = Number(root.dataset.autoplayMs || 0);
    this.bind();
    this.render();
    this.start();
  }

  bind() {
    this.prev?.addEventListener('click', () => this.go(this.index - 1));
    this.next?.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.go(Number(dot.dataset.catalinaDot)));
    });
    this.root.addEventListener('mouseenter', () => this.stop());
    this.root.addEventListener('mouseleave', () => this.start());
    this.root.addEventListener('focusin', () => this.stop());
    this.root.addEventListener('focusout', () => this.start());
  }

  go(index) {
    if (!this.slides.length) return;
    if (index < 0) {
      this.index = this.slides.length - 1;
    } else if (index >= this.slides.length) {
      this.index = 0;
    } else {
      this.index = index;
    }
    this.render();
    this.start();
  }

  render() {
    if (!this.track) return;
    this.track.style.transform = `translateX(${-100 * this.index}%)`;
    this.dots.forEach((dot, idx) => {
      dot.classList.toggle('is-active', idx === this.index);
      dot.setAttribute('aria-current', idx === this.index ? 'true' : 'false');
    });
  }

  start() {
    this.stop();
    if (!this.interval || this.slides.length < 2) return;
    this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }
}

class CatalinaCollectionFilters {
  constructor(root) {
    this.root = root;
    this.panel = root;
    this.toggle = document.querySelector(`[data-catalina-filter-toggle][aria-controls="${root.id}"]`);
    this.buttons = Array.from(root.querySelectorAll('[data-filter-group][data-filter-value]'));
    this.clear = root.querySelector('[data-clear-filters]');
    this.sort = root.querySelector('[data-catalina-sort]');
    this.collectionHandle = root.dataset.collectionHandle || '';
    this.active = {};
    this.cards = Array.from(document.querySelectorAll('.product-grid__item product-card[data-product-id]'));
    this.items = this.cards.map((card) => card.closest('.product-grid__item')).filter(Boolean);
    this.list = this.items[0]?.parentElement || null;
    this.originalOrder = new Map(this.items.map((item, index) => [item.dataset.productId, index]));
    this.bind();
    if (!this.cards.length) return;
    this.apply();
  }

  bind() {
    this.toggle?.addEventListener('click', () => {
      const nextHidden = !this.panel.hidden;
      this.panel.hidden = nextHidden;
      this.toggle.setAttribute('aria-expanded', nextHidden ? 'false' : 'true');
    });

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.dataset.filterGroup;
        const value = button.dataset.filterValue;
        const current = this.active[group] || [];
        if (current.includes(value)) {
          this.active[group] = current.filter((entry) => entry !== value);
        } else {
          this.active[group] = current.concat(value);
        }
        this.renderButtons();
        this.apply();
      });
    });

    this.clear?.addEventListener('click', () => {
      this.active = {};
      this.renderButtons();
      this.apply();
    });

    this.sort?.addEventListener('change', () => this.apply());
  }

  renderButtons() {
    this.buttons.forEach((button) => {
      const group = button.dataset.filterGroup;
      const value = button.dataset.filterValue;
      const isActive = (this.active[group] || []).includes(value);
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  apply() {
    if (!this.cards.length) return;

    this.items.forEach((item) => {
      const card = item.querySelector('product-card[data-product-id]');
      const matchesFilters = Object.entries(this.active).every(([group, values]) => {
        if (!values.length) return true;
        const haystack = (card.dataset[group] || '').split('|').filter(Boolean);
        return values.some((value) => haystack.includes(value));
      });
      const hideGiftCard = ['all', 'frontpage', 'all-snacks'].includes(this.collectionHandle)
        && card.dataset.productType === 'gift-cards';
      const matches = matchesFilters && !hideGiftCard;
      card.dataset.catalinaHidden = matches ? 'false' : 'true';
      item.hidden = !matches;
    });

    this.sortItems();
  }

  sortItems() {
    if (!this.list || !this.sort) return;

    const value = this.sort.value || 'featured';
    const sortedItems = [...this.items].sort((a, b) => {
      const aCard = a.querySelector('product-card[data-product-id]');
      const bCard = b.querySelector('product-card[data-product-id]');
      const aPrice = Number(aCard?.dataset.priceCents || 0);
      const bPrice = Number(bCard?.dataset.priceCents || 0);
      const aTitle = aCard?.dataset.sortTitle || '';
      const bTitle = bCard?.dataset.sortTitle || '';

      if (value === 'price-asc') return aPrice - bPrice;
      if (value === 'price-desc') return bPrice - aPrice;
      if (value === 'title-asc') return aTitle.localeCompare(bTitle);

      if (['all', 'frontpage', 'all-snacks'].includes(this.collectionHandle)) {
        const typeOrder = {
          cereal: 0,
          'snack-mix': 1,
          granola: 2,
          'chocolate-cookie-bars': 3,
          bundles: 4,
          bundle: 4,
        };
        const aType = typeOrder[aCard?.dataset.productType] ?? 5;
        const bType = typeOrder[bCard?.dataset.productType] ?? 5;
        if (aType !== bType) return aType - bType;
      }

      const aIndex = this.originalOrder.get(a.dataset.productId) ?? 0;
      const bIndex = this.originalOrder.get(b.dataset.productId) ?? 0;
      return aIndex - bIndex;
    });

    for (const item of sortedItems) {
      this.list.appendChild(item);
    }
  }
}

class CatalinaPdpCartBridge {
  constructor(button) {
    this.button = button;
    this.pending = false;
    this.bind();
  }

  bind() {
    this.button.addEventListener('click', async () => {
      if (this.pending) return;
      this.pending = true;

      const beforeCount = await this.fetchCartCount();
      window.setTimeout(async () => {
        const afterCount = await this.fetchCartCount();
        if (afterCount > beforeCount) {
          document.querySelector("[data-testid='cart-drawer-trigger']")?.click();
        }
        this.pending = false;
      }, 1200);
    });
  }

  async fetchCartCount() {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      });
      if (!response.ok) return 0;
      const payload = await response.json();
      return Number(payload.item_count || 0);
    } catch (error) {
      return 0;
    }
  }
}

class CatalinaFaqTabs {
  constructor(root) {
    this.root = root;
    this.groups = Array.from(root.querySelectorAll(':scope > .catalina-faq-group'));
    if (this.groups.length < 2) return;
    this.nav = document.createElement('nav');
    this.nav.className = 'catalina-faq-tabs';
    this.nav.setAttribute('aria-label', 'FAQ categories');
    this.buttons = this.groups.map((group, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'catalina-faq-tabs__button';
      button.textContent = group.querySelector('h2')?.textContent?.trim() || `Category ${index + 1}`;
      button.addEventListener('click', () => this.show(index));
      this.nav.appendChild(button);
      return button;
    });
    root.prepend(this.nav);
    this.show(0);
  }

  show(activeIndex) {
    this.groups.forEach((group, index) => {
      const active = index === activeIndex;
      group.hidden = !active;
      this.buttons[index].classList.toggle('is-active', active);
      this.buttons[index].setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-catalina-hero]').forEach((root) => {
    new CatalinaHeroSlider(root);
  });

  document.querySelectorAll('[data-catalina-collection-controls]').forEach((root) => {
    new CatalinaCollectionFilters(root);
  });

  document.querySelectorAll("[data-testid='standalone-add-to-cart']").forEach((button) => {
    new CatalinaPdpCartBridge(button);
  });

  document.querySelectorAll('.catalina-page-body').forEach((root) => {
    if (root.querySelector('.catalina-faq-group')) {
      new CatalinaFaqTabs(root);
    }
  });
});
